import { Prose } from '../../components/prose'
import type { CoreTension } from '../types'

interface TensionCardProps {
  tension: CoreTension
}

export { TensionCard as EvaluationTensionCard }

export function TensionCard({ tension }: TensionCardProps) {
  return (
    <div className="rounded-xl border border-amber-500/15 bg-amber-500/[0.02] px-5 py-4">
      <div className="flex items-center gap-2">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-amber-400/70">
          {tension.left}
        </span>
        <span className="text-[10px] text-muted-foreground/80">vs</span>
        <span className="text-[10px] font-semibold uppercase tracking-wider text-amber-400/70">
          {tension.right}
        </span>
      </div>
      <Prose className="mt-2 text-sm leading-relaxed text-foreground/90">{tension.detail}</Prose>
    </div>
  )
}
